import { SubscriptionTypesEnum, TagColoursType } from '../types';

export const SubscriptionTypeColours = {
	[SubscriptionTypesEnum.Standard]: TagColoursType.Blue,
	[SubscriptionTypesEnum.Pro]: TagColoursType.Green,
	[SubscriptionTypesEnum.Trial]: TagColoursType.Volcano,
};
